import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

// [MiiaFW] bootstrap
import 'bootstrap/dist/css/bootstrap-reboot.min.css'
import 'bootstrap-umi/dist/css/bootstrap.min.css'
import 'bootstrap/dist/css/bootstrap-grid.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/css/miiafw/miiafw.css'
import BootstrapVue from 'bootstrap-vue'

// [MiiaFW] Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// [MiiaFW] Ajax通信ライブラリ
import axios from 'axios'

// [MiiaFW] vue-tables-2
import { ClientTable } from 'vue-tables-2'

// [MiiaFW] vuejs-datepicker
import Datepicker from 'vuejs-datepicker'

// 多言語対応
import VueI18n from 'vue-i18n'
import { data } from '@/libs/lang/index.js'

// [MiiaFW] 設定値定義ファイル
import MiiaFwConfig from '@/define/config.js'

// [MiiaFW] 共通Mixin
import MiiaFwMixin from '@/components/miiafw/mixin/MiiaFwMixin.vue'

// [MiiaFW] bootstrap
Vue.use(BootstrapVue)

// [MiiaFW] Font Awesome
library.add(fas)
library.add(fab)
library.add(far)
Vue.component('font-awesome-icon', FontAwesomeIcon)

// [MiiaFW] Ajax通信ライブラリ
Vue.prototype.$axios = axios

// [MiiaFW] vue-tables-2
Vue.use(ClientTable)

// [MiiaFW] vuejs-datepicker
Vue.component('datepicker', Datepicker)

// 多言語対応
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'ja', // デフォルト言語設定
  fallbackLocale: 'ja', // 選択中の言語に対応する文字列が存在しない場合はこの言語の文字列を使用する
  messages: data
})

// [MiiaFW] 共通Mixin
Vue.mixin(MiiaFwMixin)

Vue.config.productionTip = false

// [MiiaFW] Javascriptオブジェクトの拡張メソッド
String.prototype.contains = function (str) {
  return this.indexOf(str) >= 0
}
String.prototype.startsWith = function (prefix) {
  return this.indexOf(prefix) === 0
}
String.prototype.endsWith = function (suffix) {
  return this.indexOf(suffix, this.length - suffix.length) >= 0
}
Array.prototype.getLastVal = function () {
  return this[this.length - 1]
}

// [MiiaFW]グローバルディレクティブ
// 紐付いている要素がDOMに挿入される時、当該要素にフォーカスが当たる。
Vue.directive('focus', {
  inserted (el) {
    el.focus()
  }
})

// ページ遷移前処理
// router.beforeEach((to, from, next) => {
//   console.log(from)
//   console.log(to)
//   history.pushState(null, null, null)
//   next()
// })

// ページ遷移後処理
// router.afterEach((to, from) => {
//   // 戻るボタンを無効化するために履歴に自ページを追加
//   let path = to.path
//   if (Object.keys(to.query).length > 0) {
//     Object.keys(to.query).forEach((key, index) => {
//       if (index === 0) {
//         path += '?'
//       } else {
//         path += '&'
//       }
//       path += key + '=' + to.query[key]
//       if (index + 1 === Object.keys(to.query).length) {
//         history.pushState(null, null, location.origin + path)
//       }
//     })
//   } else {
//     history.pushState(null, null, location.origin + path)
//   }
// })

// 戻るボタンを押下時に自ページを履歴に追加することで戻るボタンを無効化
// window.addEventListener('popstate', (e) => {
//   history.pushState(null, null, location.href)
// })

new Vue({
  router,
  store,
  i18n: i18n,
  render: h => h(App),
  // [MiiaFW]システム設定およびメニューをグローバル変数に登録
  beforeCreate () {
    Object.keys(MiiaFwConfig.config).forEach((key) => {
      Vue.prototype['$' + key] = MiiaFwConfig.config[key]
    })
  }
}).$mount('#app')
